var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5207\u7247") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5FEB\\u670D\\u7F51\\u767B\\u5F55\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.2-\\u627E\\u56DE\\u5BC6\\u7801",
    transform: "translate(-572.000000, -404.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u677F\\u5757/\\u627E\\u56DE\\u60A8\\u7684\\u5BC6\\u7801",
    transform: "translate(0.000000, 220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u677F\\u5757/\\u624B\\u673A\\u53F7\\u7801\\u9A8C\\u8BC1",
    transform: "translate(536.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u6807/\\u624B\\u673A",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/\\u7EBF\\u578B/20\\xD720/\\u624B\\u673A",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u900F\\u660E\\u5C42",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,4 C30.209139,4 32,5.790861 32,8 L32,32 C32,34.209139 30.209139,36 28,36 L12,36 C9.790861,36 8,34.209139 8,32 L8,8 C8,5.790861 9.790861,4 12,4 L28,4 Z M28,6 L24,6 C24,7.1045695 23.1045695,8 22,8 L18,8 C16.8954305,8 16,7.1045695 16,6 L12,6 C10.9743283,6 10.1289857,6.77208038 10.0134555,7.76675775 L10,8 L10,32 C10,33.0256717 10.7720804,33.8710143 11.7667577,33.9865445 L12,34 L28,34 C29.0256717,34 29.8710143,33.2279196 29.9865445,32.2332423 L30,32 L30,8 C30,6.97432832 29.2279196,6.12898568 28.2332423,6.01345546 L28,6 Z M23,30 C23.5522847,30 24,30.4477153 24,31 C24,31.5522847 23.5522847,32 23,32 L17,32 C16.4477153,32 16,31.5522847 16,31 C16,30.4477153 16.4477153,30 17,30 L23,30 Z",
    id: "\\u5F62\\u72B6",
    fill: "#CF1322"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.fea0d85ed2b79fee7ca5017e4b1d45c0.svg";
export { ForwardRef as ReactComponent };